import findChildrenNode from "./findChildrenNode";

function findAllPathFromTarget(nodes, edges, targetNodeId) {
    let all_path = [];
    const childs = findChildrenNode(nodes, edges, targetNodeId);

    function findPath(currentPath, targetId) {
        const childPaths = findChildrenNode(nodes, edges, targetId);
        const newPath = [...currentPath, targetId];
        if (childPaths.length > 0) {
            for (const child of childPaths) {
                findPath(newPath, child);
            }
        } else {
            const all_child_in_path = {
                path: newPath,
            };
            all_path.push(all_child_in_path);
        }
    }

    if (childs.length > 0) {
        let path = [targetNodeId];
        for (const child of childs) {
            findPath(path, child);
        }
    }

    return all_path;
}

export default findAllPathFromTarget;